import { postsRoutes } from './posts/routes.js';
import { engagementRoutes } from './engagement/routes.js';
import { profileRoutes } from './profile/routes.js';
import { searchRoutes } from './search/routes.js';
import { networkRoutes } from './network/routes.js';
import { communityRoutes } from './community/routes.js';
import { chatRoutes } from './chat/routes.js';
import { pollRoutes } from './poll/routes.js';
import { fundraiserRoutes } from './fundraiser/routes.js';
import { businessRoutes } from './business/routes.js';
import { eventRoutes } from './event/routes.js';
import { promotionRoutes } from './promotion/routes.js';
import { moderationRoutes } from './moderation/routes.js';
import { calendarRoutes } from './calendar/routes.js';
import { subscriptionRoutes } from './subscription/routes.js';
import { paymentRoutes } from './payment/routes.js';
import { settingsRoutes } from './settings/routes.js';
import { helpRoutes } from './help/routes.js';
import { notificationsRoutes } from './notifications/routes.js';
import { authRoutes } from './auth/routes.js';
import { socialAuthRoutes } from './social-auth/routes.js';
import { taxonomyRoutes } from './taxonomy/routes.js';
import { onboardingRoutes } from './onboarding/routes.js';
import { storageRoutes } from './storage/routes.js';
import { donationRoutes } from './donation/routes.js';
import { familyRoutes } from './family/routes.js';
import { contentDraftRoutes } from './content-draft/routes.js';
export * from './posts/schemas.js';
export * from './posts/routes.js';
export * from './engagement/routes.js';
export * from './profile/routes.js';
export * from './search/routes.js';
export * from './network/routes.js';
export * from './community/routes.js';
export * from './chat/routes.js';
export * from './poll/routes.js';
export * from './fundraiser/routes.js';
export * from './business/routes.js';
export * from './event/routes.js';
export * from './promotion/routes.js';
export * from './moderation/routes.js';
export * from './calendar/routes.js';
export * from './subscription/routes.js';
export * from './payment/routes.js';
export * from './settings/routes.js';
export * from './help/routes.js';
export * from './notifications/routes.js';
export * from './auth/routes.js';
export * from './social-auth/routes.js';
export * from './taxonomy/routes.js';
export * from './onboarding/routes.js';
export * from './storage/routes.js';
export * from './donation/routes.js';
export * from './content-draft/routes.js';
export * from './family/routes.js';
export const routes = {
    family: familyRoutes,
    posts: postsRoutes,
    engagement: engagementRoutes,
    profile: profileRoutes,
    search: searchRoutes,
    network: networkRoutes,
    community: communityRoutes,
    chat: chatRoutes,
    poll: pollRoutes,
    fundraiser: fundraiserRoutes,
    business: businessRoutes,
    event: eventRoutes,
    promotion: promotionRoutes,
    moderation: moderationRoutes,
    calendar: calendarRoutes,
    subscription: subscriptionRoutes,
    payment: paymentRoutes,
    settings: settingsRoutes,
    help: helpRoutes,
    notifications: notificationsRoutes,
    auth: authRoutes,
    socialAuth: socialAuthRoutes,
    taxonomy: taxonomyRoutes,
    onboarding: onboardingRoutes,
    storage: storageRoutes,
    donation: donationRoutes,
    contentDraft: contentDraftRoutes,
};
//# sourceMappingURL=index.js.map